import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { PostUpdateQuote } from 'services/additionalServices/postUpdateQuote';
import { PostCreateOrder } from 'services/additionalServices/postCreateOrder';
import { ParamsDataProductCartAddServices, ParamsProduct, ParamsBodyCartState, ParamsDataPostUpdateQuote, ParamsBodyParseProductCart, ParamsBodyFilterPostUpdateQuote, ParamsBodyPostCreateOrder, ParamsDataPostCreateOrder } from 'utils/typeServices';

const defaultCart = {
    customerId: 0,
    cD_PEDIDO: 0,
    cD_COTACAO: 0,
    productAdd: [],
    vL_TOTAL_Cart: ''
}

const useShoppingCartuseAddServices = () => {
    const navigate = useNavigate();
    const [dataProductCartAddServices, setDataProductCartAddServices] = useState<ParamsDataProductCartAddServices>(JSON.parse(JSON.stringify(defaultCart)));
    const [dataChooseQuoteItemsAddServices, setDataChooseQuoteItemsAddServices] = useState<ParamsDataPostUpdateQuote | false>();
    const [dataCreateOrder, setDataCreateOrder] = useState<ParamsDataPostCreateOrder | false>();

    const handleClearShoppingCartAddServices = () => {
        setDataProductCartAddServices(JSON.parse(JSON.stringify(defaultCart)));
        setDataChooseQuoteItemsAddServices(undefined);
    };

    const handleParseProductCartAddServices = ({ body }: { body: ParamsBodyParseProductCart }) => {
        let productAdd: Array<ParamsProduct> = [];
        let totalAux = 0;

        body.quoteItemsChooses.map(({ cD_COTACAO_ITEM, cD_PRODUTO, nR_TIPO_PRODUTO, nR_PORCENTAGEM_INDENIZACAO, dS_TITULO_SITE, vL_TOTAL }) =>
            nR_TIPO_PRODUTO !== 12 && (
                productAdd.push({ cD_COTACAO_ITEM, cD_PRODUTO, nR_TIPO_PRODUTO, nR_PORCENTAGEM_INDENIZACAO, nM_PRODUTO: dS_TITULO_SITE, vL_TOTAL }),
                totalAux = totalAux + parseFloat(vL_TOTAL.split(' ')[1].replace('.', '').replace(',', '.'))
            )
        );

        if (productAdd) {
            setDataProductCartAddServices({
                ...dataProductCartAddServices,
                customerId: body.customerId,
                cD_PEDIDO: body.cD_PEDIDO,
                cD_COTACAO: body.cD_COTACAO,
                productAdd: productAdd,
                vL_TOTAL_Cart: `${totalAux.toFixed(2)}`.replace('.', ',')
            });
        }
    }

    const handleProductCartAddServices = ({ bodyBase, body, addProduct }: { bodyBase: ParamsBodyCartState, body: ParamsProduct, addProduct: boolean }) => {
        let cartAux = dataProductCartAddServices;

        if (addProduct) {
            if (body.nR_TIPO_PRODUTO === 13 && body.nM_PRODUTO?.includes("Pacote")) {
                cartAux.productAdd = dataProductCartAddServices.productAdd.filter(({ nM_PRODUTO }) => !nM_PRODUTO?.includes("Pacote"));
            }

            cartAux.productAdd.push(body);
        } else {
            cartAux.productAdd = dataProductCartAddServices.productAdd.filter(({ cD_PRODUTO }) => cD_PRODUTO !== body.cD_PRODUTO);
        }

        let totalAux = 0;

        cartAux.productAdd.map(({ vL_TOTAL }) => totalAux = totalAux + parseFloat(vL_TOTAL.split(' ')[1].replace(',', '.')));
        cartAux.vL_TOTAL_Cart = `${totalAux.toFixed(2)}`.replace('.', ',');


        setDataProductCartAddServices({
            customerId: bodyBase.customerId,
            cD_PEDIDO: bodyBase.cD_PEDIDO,
            cD_COTACAO: bodyBase.cD_COTACAO,
            productAdd: cartAux.productAdd,
            vL_TOTAL_Cart: cartAux.vL_TOTAL_Cart
        });
    }

    const handlePostChooseQuoteItemsAddServices = async ({ CD_CANAL_VENDA, CD_COTACAO, CD_PESSOA_PARCEIRO, CD_PESSOA_PARCEIRO_ESTABELECIMENTO, CD_PESSOA_VENDEDOR }: ParamsBodyFilterPostUpdateQuote, isWebView: boolean) => {
        const listProductAux = dataProductCartAddServices.productAdd.map(({ cD_COTACAO_ITEM, cD_PRODUTO, nR_TIPO_PRODUTO }) => {
            return { cD_COTACAO_ITEM, cD_PRODUTO, nR_TIPO_PRODUTO }
        });

        const data = await PostUpdateQuote({
            body: listProductAux,
            bodyFilter: {
                CD_COTACAO,
                CD_CANAL_VENDA,
                CD_PESSOA_PARCEIRO,
                CD_PESSOA_VENDEDOR,
                CD_PESSOA_PARCEIRO_ESTABELECIMENTO
            }
        });

        if (data) {
            setDataChooseQuoteItemsAddServices(data);
            navigate(`${isWebView ? 'wb/' : ''}servicos-adicionais/pagamento`);
        } else {
            setDataChooseQuoteItemsAddServices(false);
        }
    }

    const handlePostCreateOrderAddServices = async (body: ParamsBodyPostCreateOrder, isWebView: boolean) => {
        const data = await PostCreateOrder({ body });

        if (data?.IsSuccess) {
            setDataCreateOrder(data.Data);
            navigate(`${isWebView ? 'wb/' : ''}servicos-adicionais/resumo-pedido`);
        } else {
            setDataCreateOrder(false);
        }
    }




    return { dataProductCartAddServices, dataChooseQuoteItemsAddServices, dataCreateOrder, handleProductCartAddServices, handlePostChooseQuoteItemsAddServices, handleClearShoppingCartAddServices, handleParseProductCartAddServices, handlePostCreateOrderAddServices };
}

export default useShoppingCartuseAddServices;